import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getStoreLocalData, getUserData } from "../utils/localStorage";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import StoreMenu from "./StoreMenu";
import {
  getBrandCashBook,
  getStoreCashBook,
} from "../services/Cashbook/Cashbook";
import SchedularModal from "./SchedularModal";
import ButtonLink from "../ButtonLink";
import useStoreCashBook from "./StoreContext/useStoreCashBook";
import { localeDateEndDate, localeDateStartDate } from "../constants/DateUtil/DateUtil";
const { innerWidth: width, innerHeight: height } = window;

const StoreCashbook = () => {
  const navigate = useNavigate();

  const { storeData, brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;  

  const storeId = storeData.id;
  let brandId = brandProfileData.id;
  
  const enabledDownloadData =  storeData.enabledDownloadData // Enable download for income/expense and cashbook

  const {
    schedularDate,
    setSchedularDate,
    sortingData,
    setSortingData,
  } = useStoreCashBook();

  const [cashbookData, setCashbookData] = useState([]);
  const [cashbookBalanceData, setCashbookBalanceData] = useState("");
  const [loading, setLoading] = useState(false);

  // const [sortingData, setSortingData] = useState(false);

  const handleSortData = () => {
    setSortingData(!sortingData);
  };

  const [visible, setVisible] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  let initialStartDate = new Date();
  // initialStartDate.setDate(1);
  // initialStartDate.setMonth(initialStartDate.getMonth()); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [analyticsSchedularModalVisible, setAnalyticsSchedularModalVisible] =
    useState(false);
  // const [schedularDate, setSchedularDate] = useState({});

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const handleCalendarModal = () => {
    setAnalyticsSchedularModalVisible(true);
  };

  const fetchCashBook = (data) => {
    setLoading(true);
    getStoreCashBook(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const formatDateLedger = (dateString) => {
            // const parsedDate = new Date(dateString?.replace('Z', '')); // Keep the "Z" to correctly interpret UTC
            const parsedDate = new Date(dateString)
        
            return parsedDate.toLocaleString("en-GB", {
              month: "2-digit",
              day: "2-digit",
              year: "2-digit",
              hour12: true,
              hour: "numeric",
              minute: "2-digit",
            });
          };

          const UseFullData =  Res.cashbookDTOList.map((item) => ({
            dateOfOrder: formatDateLedger(item.createdDate),
            particular: item.particular,
            module: item.module,
            openingBalance: item.openingBalance,
            receipt: item.receipt,
            expense: item.expense,
            userName: item.userName,
            closingBalance: item.closingBalance,
          }))
          setCashbookData(UseFullData);
          setCashbookBalanceData(Res.cashbookBalance);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      brandId: brandId,
      storeIds: [storeId],
      sortBy: "createdDate",
      sortOrder: sortingData ? "desc" : "asc",
      limit: 1000000,
      startDate: schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate?.startDate))
        : localeDateStartDate(new Date(startDate)),
      endDate: schedularDate?.endDate ? localeDateEndDate(new Date(schedularDate?.endDate)) : localeDateEndDate(new Date(endDate)),
    };
    fetchCashBook(data);
  }, [sortingData,schedularDate]);

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();

    return data.filter((item) =>
      Object.values(item).some((value) =>
        typeof value === "string" || typeof value === "number"
          ? value.toString().toLowerCase().includes(searchLower)
          : false
      )
    );
  };
  

  const filteredOrderInfoData = filterData(cashbookData, searchTerm);

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(filteredOrderInfoData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Cashbook");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };


  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const header = (
    <div className="flex flex-wrap align-items-center justify-content-between gap-2">
      <span className="text-xl text-900 font-bold">
        Balance : {storeLocalData?.currencySymbol} {Number(cashbookBalanceData).toFixed(2)}
      </span>
    </div>
  );

  const Receipt = (
    <div>
      <span className="text-md ">
        Receipt ({storeLocalData?.currencySymbol})
      </span>
    </div>
  );

  const Expense = (
    <div >
      <span className="text-md ">
        Expense ({storeLocalData?.currencySymbol})
      </span>
    </div>
  );

  const RenderCashBook = () => {
    return (
      <DataTable
      showGridlines
        value={filteredOrderInfoData}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        stripedRows
        scrollable
        scrollHeight={height - 160}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="dateOfOrder"
          header="Date"
          style={{ width: "100px" }}
          body={(rowData) => rowData?.dateOfOrder?.split(",")[0]}
        />
        <Column field="particular" header="Particular"></Column>
        <Column field="particular" style={{ width: "200px" }} header="Customer Name" body={(rowData) => rowData?.particular?.split(",")[2]} />
        <Column
          field="userName"
          header="Created By"
          style={{ width: "200px" }}
        ></Column>
        <Column
          field="module"
          header="Module"
          style={{ width: "150px" }}
        ></Column>
        <Column
          field="openingBalance"
          header="Opening Balance"
          style={{ width: "120px" }}
          body={(rowData) => Number(rowData?.openingBalance?.toFixed(enabledAmountRoundOff))}

        ></Column>
        <Column
          field="receipt"
          header={Receipt}
          style={{ width: "120px" }}
        ></Column>
        <Column
          field="expense"
          header={Expense}
          style={{ width: "120px" }}
        ></Column>
        
        <Column
          field="closingBalance"
          header="Closing Balance"
          style={{ width: "120px" }}
          body={(rowData) => Number(rowData?.closingBalance?.toFixed(enabledAmountRoundOff))}

        ></Column>
      </DataTable>
    );
  };
  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5 flex justify-content-start align-items-center">
              <p className="text-white text-2xl font-bold uppercase">
                Cash Book
              </p>
            </div>
          </div>
          {enabledDownloadData && (
            <div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                    width: 30,
                  }}
                />
              </div>
            </div>)}
          <div
            onClick={() => navigate("/Income-expense")}
            className="flex cursor-pointer ml-2 pr-4"
          >
            <div className="py-2 ">
              <img
                src={"images/increase.png"}
                style={{
                  height: 25,
                  width: 25,
                  filter: "#fff",
                }}
              />
            </div>
            <div className="ml-2 flex justify-content-between  align-items-center">
              <div>
                <p className="text-xl font-semibold" style={{ color: "#fff" }}>
                  Income/ Expense
                </p>
              </div>
            </div>
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            onClick={() => handleSortData()}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            {!sortingData ? (
              <i
                className="pi  pi-sort-amount-up-alt"
                style={{ fontSize: "25px", marginRight: 30, color: "#fff" }}
              ></i>
            ) : (
              <i
                className="pi  pi-sort-amount-down"
                style={{ fontSize: "25px", marginRight: 30, color: "#fff" }}
              ></i>
            )}
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="  mt-3">
        <div className="my-2 mx-5 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={"Search"}
                value={searchTerm}
                keyboardType={"default"}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm && (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-3xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          )}
          <div className="flex justify-content-center align-items-center ml-3">
            <p className="text-2xl font-semibold">
              Balance : {Number(cashbookBalanceData).toFixed(enabledAmountRoundOff)}
            </p>
          </div>
        </div>

        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : filteredOrderInfoData?.length > 0 ? (
          <div className="mx-4 report-table">{RenderCashBook()}</div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Cash Book Found</p>
          </div>
        )}
      </div>
      <SchedularModal
        schedularModalVisible={analyticsSchedularModalVisible}
        setSchedularModalVisible={setAnalyticsSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
      />
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default StoreCashbook;
